import ActiveNdasModal from './ActiveNdasModal.component';

export default ActiveNdasModal;